import config from "../../../../public/config.json"

const alarmStatus = [
	{ text: "Acknowledged", action: "Acknowledge", value: "ACKNOWLEDGED" },
	{ text: "Active", action: "Active", value: "ACTIVE", system: true },
	{ text: "Disabled", action: "Disable", value: "DISABLED" },
	{ text: "Normal", action: "Normal", value: "NORMAL", system: true },
	{ text: "Snoozed", action: "Snooze", value: "SNOOZE_DISABLED" },
];
Object.freeze(alarmStatus);

const alarmTypes = [
	{ text: "Controller CPU Temperature", value: "Controller-cputemp", unit: "°C" },
	{ text: "Controller CPU Usage", value: "Controller-cpuusage", unit: "%" },
	{ text: "Controller Connection", value: "Controller-connection" },
	{ text: "Controller Disk", value: "Controller-disk", unit: "MB" },
	{ text: "Controller Memory", value: "Controller-memory", unit: "MB" },
	{ text: "Device Battery", value: "Device-battery", unit: "%" },
	{ text: "Device Connection", value: "Device-connection" },
	{ text: "Wifi", value: "Wifi", unit: "SNR" },
];
Object.freeze(alarmTypes);

const severityTypes = [
	{ text: "Critical", value: "CRITICAL" },
	{ text: "Degraded", value: "DEGRADED" },
	{ text: "Normal", value: "NORMAL" },
];
Object.freeze(severityTypes);

const descriptions = config.severityDescriptions;
Object.freeze(descriptions);

const summaryText = {
	open_alarms: "Recent Alarms",
	controller_alarms: "Controller Alarms",
	device_alarms: "Device Alarms",
	wifi_alarms: "Wifi Alarms",
};
Object.freeze(summaryText);

const summaryFilters = config.summaryFilters;
Object.freeze(summaryFilters);

export {
	alarmStatus,
	alarmTypes,
	severityTypes,
	descriptions,
	summaryText,
	summaryFilters,
};
